import { IFilterItem } from '@/types/api';
import { IFiltersEnumType } from '@/types/enums';

import { INavbarMenu } from '@/mock-data/navbar-menu';

export interface IPostClientEmail {
  Server: string;
  Emails: string[];
}

export interface IRolesTableData {
  Id: number;
  IsRemovable: boolean;
  CustomerId: any;
  Customer: Customer;
  Type: number;
  Name: string;
  Parent: any;
  Owner: any;
  ParentId: any;
  ParentName: any;
  ExternalId: any;
  CreateOfDate: string;
  ChangeDate: any;
  Counter: number;
  Children: any;
  Quota: Quota;
  PostClientEmails?: IPostClientEmail[];
}

export interface Customer {
  Name: string;
  Id: number;
  Count: number;
}

export interface IRolesData {
  Items: IRolesTableData[];
  TotalCount: number;
}

export interface IRemoveUserDto {
  RolesId: number;
  TransferRolesId: number[];
}

export interface IRemoveUser {
  isChecked: boolean;
  id: number;
  firstName?: string | null;
  middleName?: string | null;
  email?: string | null;
  transferUserId: number | null;
}

export interface IRemoveResponse {
  TaskIds: number[];
}

export interface IRemoveStatusResponse {
  Results: { Status: number; UserId: number }[];
}

export interface DefaultFilter {
  Items: IFilterItem[];
  Type: IFiltersEnumType;
}

export interface IFilterItemsResponse {
  FilterItems: IFilterItem[];
  TotalCount: number;
}
export interface DefaultFiltersResponse {
  DefaultFilters: DefaultFilter[];
}

export interface IFilterItemsRequest {
  Type: number;
  Query?: string;
  Count: number;
  Offset: number;
}
export interface IFiltersResponse {
  filters: INavbarMenu[];
}

export enum OrderType {
  Local = 0,
  Ldap = 1
}

export interface IRolesInfoCommon {
  Id: number;
  CustomerId: any;
  Customer: Customer;
  Type: number;
  Name: string;
  Origin: OrderType;
  Parent: Parent;
  Owner: Owner;
  ParentId: any;
  ParentName: any;
  ExternalId: any;
  CreateOfDate: string;
  ChangeDate: any;
  Counter: any;
  Children: any;
  Quota: Quota;
  AllowedRoles: AllowedRole[];
}

export interface Customer {
  Name: string;
  Id: number;
  Count: number;
}

export interface Parent {
  Name: string;
  Id: number;
  Count: number;
}

export interface Owner {
  Name: string;
  Id: number;
  Count: number;
}

export interface AllowedRole {
  Name: string;
  Id: number;
}

export interface Quota {
  Name: string;
  Id: number;
}
